import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default [
  {
    path: '/inventario-tec',
    name: 'inventario-tec',
    component: () =>
      import('@/views/inventarioTec/InventarioTec.vue'),
  },
];
